import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import pathConstant from "../../../utils/path.constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { api } from "../../../services/apis/auth-api/apiUrl";
import { FORGOT_PASSWORD_VERIFICATION_END_POINT } from "../../../config/config";
import { AxiosError } from "axios";

export default function ForgotPassword (){
    const [email, setEmail] = useState<string>('');
    const [status, setStatus] = useState({stat : false, msg : ''});
    const [loading, setLoading] = useState<boolean>(false);

    const verifyEmail = async() => {
        if(email === '') {
            setStatus({stat : false, msg: 'Email is required!'});
            return false;
        }
        setLoading(true);
        try{
            await api.get(FORGOT_PASSWORD_VERIFICATION_END_POINT+email);
            setStatus({stat : true, msg: 'Email verified. Link was sent to your email'});
            setEmail('');
            setLoading(false);
        }catch(e){
            const error = (e as AxiosError);
            if(error.request?.status === 400){
                setStatus({stat : false, msg: 'Email not found!'});
            }else{
                setStatus({stat : false, msg: 'An error occured!'});
            }
            setLoading(false);
        }
    }

    return (
        <div className="main-container">
            <Helmet>
                <title>Forgot password</title>
            </Helmet>
            <div className="auth-card">
                <div className="text-lg">
                    <FontAwesomeIcon icon={faTriangleExclamation} className="text-yellow-500" /> &nbsp;
                    Forgot password?
                </div>
                <div>
                    <form>
                        <div className="my-2 text-center">
                            <p className="italic text-yellow-600">
                                Change password link will be sent to your email once verified.
                            </p>
                        </div>
                        <div className="text-sm">
                            <p className={!status.stat ? 'text-red-500' : 'text-green-500'}>
                                {status.msg}
                            </p>
                        </div>
                        <div className="input-container text-gray-500">
                            <label className="text-sm">Please verify your email</label>
                            <input type="text" onChange={(e)=>setEmail(e.target.value)} value={email} className="text-box" placeholder="Email" />
                        </div>
                        <div className="input-container">
                            {loading ? (
                                <button type="button" disabled className='button button-disabled'>
                                    <FontAwesomeIcon className='animate-spin' icon={faSpinner} /> Verifying email....
                                </button>
                            ) : (
                                <button type="button" onClick={verifyEmail} className="button button-vcc-primary">
                                    Verify Email
                                </button>
                            )}
                        </div>
                        <div className="text-center">
                            <Link
                             className="text-blue-500 underline"
                             to={pathConstant.SIGNIN}>
                               Return signin page
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}